const getChannel = (url) => {
  const queryChannel = url.searchParams.get("c");
  const pathChannel = url.pathname.startsWith("/c/") ? url.pathname.substring(3) : "";
  return { channel: queryChannel || pathChannel, conflicts: Boolean((queryChannel && queryChannel !== "pp") || (pathChannel && pathChannel !== "pp")) };
};

const isNative = () => Boolean(
  window.JSBridge || window.JSInterface || window.SuWin8Bridge ||
  /GameApp|SKGames|AndroidApp/.test(window.navigator.userAgent) || localStorage.getItem("fromApp")
);

const appendReferrer = (search, referrer) => {
  if (!search || search === "?") return `?${referrer}`;
  return `${search}${search.endsWith("&") ? "" : "&"}${referrer}`;
};

// The SDK reads adjust_referrer asynchronously after initSdk. Keep the real
// entry value through same-channel SPA navigation without replaying old clicks.
export const preserveAdjustWebReferrer = (destination) => {
  if (typeof window === "undefined") return destination;
  try {
    if (isNative()) return destination;
    const current = new URL(window.location.href);
    const sourceChannel = getChannel(current);
    if (sourceChannel.conflicts) return destination;
    const persistedChannel = sourceChannel.channel ? "" : JSON.parse(localStorage.getItem("persist") || "{}").channel;
    if ((sourceChannel.channel || persistedChannel) !== "pp") return destination;

    // Preserve raw encoding and duplicate order: the SDK uses the last value.
    const referrerParts = current.search.substring(1).split("&").filter((part) => part === "adjust_referrer" || part.startsWith("adjust_referrer="));
    if (!referrerParts.length || !referrerParts[referrerParts.length - 1].substring("adjust_referrer=".length)) return destination;
    // The SDK decodes once. Reject malformed encoding without changing the
    // original bytes or allowing an invalid entry value to break navigation.
    decodeURIComponent(referrerParts[referrerParts.length - 1].substring("adjust_referrer=".length));

    const objectDestination = destination && typeof destination === "object" && !Array.isArray(destination);
    if (typeof destination !== "string" && !objectDestination) return destination;
    if (objectDestination && ((destination.pathname != null && typeof destination.pathname !== "string") ||
        (destination.search != null && typeof destination.search !== "string"))) return destination;
    let path;
    let search;
    let hash = "";
    if (objectDestination) {
      path = destination.pathname || current.pathname;
      search = destination.search || "";
      if (search && !search.startsWith("?")) search = `?${search}`;
    } else {
      const hashIndex = destination.indexOf("#");
      const beforeHash = hashIndex < 0 ? destination : destination.substring(0, hashIndex);
      hash = hashIndex < 0 ? "" : destination.substring(hashIndex);
      const queryIndex = beforeHash.indexOf("?");
      path = queryIndex < 0 ? beforeHash : beforeHash.substring(0, queryIndex);
      search = queryIndex < 0 ? "" : beforeHash.substring(queryIndex);
    }
    if (new URLSearchParams(search).has("adjust_referrer")) return destination;
    const target = new URL(path || current.pathname, current);
    if (!/^https?:$/.test(target.protocol) || target.origin !== current.origin) return destination;
    if (/\.(apk|aab|ipa)$/i.test(target.pathname) || /^\/(?:download(?:App)?|checkout|payment|pay)(?:\/|$)/i.test(target.pathname)) return destination;
    target.search = search;
    const targetChannel = getChannel(target);
    if (targetChannel.conflicts) return destination;

    const nextSearch = appendReferrer(search, referrerParts.join("&"));
    return objectDestination ? { ...destination, search: nextSearch } : `${path}${nextSearch}${hash}`;
  } catch (error) {
    // Navigation must keep working when storage or URL parsing is unavailable.
    return destination;
  }
};
